import React from 'react';
import Txt from '../Txt';
import { getActiveCart_inStore_me_activeCart_lineItems } from 'common/interfaces/generated/getActiveCart';
import { getProductName } from 'common/lib/commercetools';

interface Props {
  lineItem: getActiveCart_inStore_me_activeCart_lineItems;
  className?: string;
}

const LineItemCardName = (props: Props): JSX.Element => {
  const { lineItem, className } = props;

  return (
    <Txt data-testid="line-item-product-name" fontWeight="bold" className={className}>
      {getProductName(lineItem.variant)}
    </Txt>
  );
};

export default LineItemCardName;
